import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { ConfirmationMessageComponent } from './components/confirmation-message/confirmation-message.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    ConfirmationMessageComponent,
    StepperComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatCardModule,
    FontAwesomeModule,
    MatIconModule,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    StepperComponent,
    ConfirmationMessageComponent,
  ],
})
export class CoreModule {}
